import React from "react";
import { Badge, IndexTable, Link, Page, Text } from "@shopify/polaris";
import { TitleBar } from "@shopify/app-bridge-react";
import { useTranslation } from "react-i18next";
import PlaceTable from "../../components/PlaceTable";

export default function CountriesIndex({}) {
  const { t } = useTranslation();
  
  return (
    <Page fullWidth>
      <TitleBar title={t("countries.title")} breadcrumbs={[]} />
      <PlaceTable
        headings={[
          { title: t("countries.headings.name") },
          { title: t("countries.headings.status") },
          { title: t("countries.headings.locations") },
          { title: t("countries.headings.cities") },
          { title: t("countries.headings.regions") },
        ]}
        isLocationList={false}
        url="/countries"
        resourceName={{ singular: t("countries.resourceSingular"), plural: t("countries.resourcePlural") }}
        renderLocation={({
          id,
          url,
          name,
          locations_count,
          cities_count,
          regions_count,
          published,
        }) => (
          <IndexTable.Row key={id} id={id}>
            <IndexTable.Cell>
              <div style={{ padding: "var(--p-space-2) 0px" }}>
                <Link dataPrimaryLink url={url} monochrome removeUnderline>
                  <Text  variant="bodyMd" as="span" fontWeight="semibold">{name}</Text>
                </Link>
              </div>
            </IndexTable.Cell>
            <IndexTable.Cell>
              {published ? (
                <Badge status="success">{t("location.index.published")}</Badge>
              ) : (
                <Badge>{t("location.index.draft")}</Badge>
              )}
            </IndexTable.Cell>
            <IndexTable.Cell>{locations_count}</IndexTable.Cell>
            <IndexTable.Cell>{cities_count}</IndexTable.Cell>
            <IndexTable.Cell>{regions_count}</IndexTable.Cell>
          </IndexTable.Row>
        )}
      />
    </Page>
  );
}
